import React from 'react';
import { useSelector } from 'react-redux';

import { l10n } from '@ott/l10n';
import Modal, { modalIcons } from '@ott/modal';
import Button from '@ott/button';
import formatMoney from '@ott/utility-format-money';

import { selectors as virtualCardSelectors } from '@ott/shared-virtual-card-logic';

import styles from './NotEnoughBalanceModal.scss';

const { ModalWarningIcon } = modalIcons;

type Props = {
  isOpen: boolean;
  onAction: VoidFunction;
  onClose: VoidFunction;
  title?: string;
  description?: string;
  actionButtonText?: string;
};

const NotEnoughBalanceModal = ({
  isOpen,
  title = l10n('virtualCard.errors.notEnoughBalance.title'),
  description,
  actionButtonText = l10n('virtualCard.errors.notEnoughBalance.action'),
  onClose,
  onAction,
}: Props) => {
  const virtualCardPaymentCheck = useSelector(virtualCardSelectors.getPaymentCheck);

  const { data: { overdraft } = {} } = virtualCardPaymentCheck;

  if (!overdraft) {
    return null;
  }

  const overdraftString = formatMoney(overdraft.amount, {
    currencyCode: overdraft.currency,
  });

  const defaultDescription = l10n('virtualCard.errors.notEnoughBalance.description', {
    overdraftString,
  });

  return (
    <Modal
      isOpen={isOpen}
      contentOptions={{
        icon: <ModalWarningIcon />,
        title,
        footerContentNode: (
          <Button
            purpose="neutral"
            withFullWidth={true}
            onClick={onAction}
            specificLocators="not-enough-balance-modal-action-button"
          >
            {actionButtonText}
          </Button>
        ),
      }}
      onClose={onClose}
    >
      <div className={styles.description}>{description || defaultDescription}</div>
    </Modal>
  );
};

export default React.memo(NotEnoughBalanceModal);
